import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`;
